import { useMakers } from 'src/hooks/useMakers';
import { MakersContext } from 'src/stores/Makers';

type Props = {
  children: React.ReactNode;
};

export const MakerProvider: React.FC<Props> = ({ children }) => {
  const { makers } = useMakers();

  return <MakersContext.Provider value={makers ?? []}>{children}</MakersContext.Provider>;
};
